import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-21ded3c1")

_pushScopeId("data-v-21ded3c1")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", null, "질문 제목", -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", null, "질문자", -1)
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", null, "답변자", -1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", null, "질문 내용", -1)
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group grid" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", null, "답변 내용", -1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-sm-6" }
const _hoisted_23 = { class: "form-group mb-5" }
const _hoisted_24 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", null, "노출 여부", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-group mb-5" }
const _hoisted_29 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_30 = /*#__PURE__*/_createVNode("label", null, "답변 여부", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_editor = _resolveComponent("editor")
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("form", {
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
        class: { loading: _ctx.loading }
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.ask.title = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelText, _ctx.ask.title]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.ask.user.nick_name = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelText, _ctx.ask.user.nick_name]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.ask.category_id = $event)),
                disabled: "",
                required: ""
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.askCategories, (askCategory) => {
                  return (_openBlock(), _createBlock("option", {
                    key: askCategory.id,
                    value: askCategory.id
                  }, _toDisplayString(askCategory.name), 9, ["value"]))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.ask.category_id]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createVNode("textarea", {
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.ask.desc = $event)),
                rows: "22"
              }, null, 512), [
                [_vModelText, _ctx.ask.desc]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_editor, {
                ref: "customEditor",
                "set-contents": _ctx.ask.answer ?? '',
                disabled: _ctx.ask.deleted_at !== null
              }, null, 8, ["set-contents", "disabled"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, [
              _createVNode("label", _hoisted_24, [
                _hoisted_25,
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  class: "c-switch-input",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.ask.show = $event)),
                  disabled: _ctx.ask.deleted_at !== null
                }, null, 8, ["disabled"]), [
                  [_vModelCheckbox, _ctx.ask.show]
                ]),
                _hoisted_26
              ])
            ])
          ]),
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, [
              _createVNode("label", _hoisted_29, [
                _hoisted_30,
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  class: "c-switch-input",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.ask.answer_state = $event)),
                  disabled: _ctx.ask.deleted_at !== null,
                  onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.validateAnswer && _ctx.validateAnswer(...args)))
                }, null, 40, ["disabled"]), [
                  [_vModelCheckbox, _ctx.ask.answer_state]
                ]),
                _hoisted_31
              ])
            ])
          ])
        ]),
        (_ctx.ask.deleted_at == null)
          ? (_openBlock(), _createBlock(_component_SubmitButton, {
              key: 0,
              text: "저장",
              loadingText: " Saving...",
              isSubmitting: _ctx.isSubmitting
            }, null, 8, ["isSubmitting"]))
          : _createCommentVNode("", true)
      ], 34)
    ])
  ]))
})